// removed by extract-text-webpack-plugin
module.exports = {"component":"_1222cH9MWls-uZFFSeybbt","leftBig":"vn0_fEaX_g2SUHSgTVzkF","rightContainer":"_1Xmr1jv2Joc8cn-vRM8xbn","right1":"_1PAj-Rfn3HDvC4-YcXVdo_","right2":"_2WWPX0Mrj0BiKxqRrGOhv_","right3":"_1iSgZo4hMmvpAEP91iamIu","right4":"_2B6NOZJjngYlhrtZ52-S7c","right5":"CpGAAb5kbVLlwsH0ufbYx","right6":"_2gNX-_4Z-1Q0thepkIIZNy","ding_img":"_2fHuMiKVql-Ug-VqfXayj8","ml6":"_2BzyiqrJGY7rsWlrJvNixt","mfw_sx_ul":"_1gcR3lT-hnWTDF7qFMRpms","mb":"_2LrMQLlL1QA7Nwi05qig54"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceMarketMiddleFilterItem/ServiceMarketMiddleFilterItem.scss
 ** module id = 1027
 ** module chunks = 0
 **/